/* eslint-disable */
import { ILeave } from 'src/interfaces';
import http from './http';
import axios, { AxiosError } from 'axios';

class LeaveModuleService {
  static getLeaves(params: any): Promise<{ items: ILeave[]; meta: { totalItems: number } }> {
    let stringParams = '';
    for (const key in params) {
      if (stringParams === '') {
        stringParams += `${key}=${params[key]}`;
      } else {
        stringParams += `&${key}=${params[key]}`;
      }
    }
    return http
      .get(`/leave/all?${stringParams}`, {
        headers: { companyId: params.companyId },
      })
      .then(resp => resp.data);
  }

  static leaveStatus(values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .put('/leave/status-change', values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }

  static leaveUpdate(leaveId: string, values: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .patch(`/leave/update/${leaveId}`, values)
        .then(() => {
          resolve();
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          }
        });
    });
  }
}
export default LeaveModuleService;
